import React from "react";
import { PawPrint, Dog, Cat, Stethoscope } from "lucide-react";
import Reveal from "../Reveal";

const logos = ["logo-1", "logo-2", "logo-3", "logo-4", "logo-5", "logo-11"];

const values = [
  { icon: Dog, title: "Our Vision", points: [
    "To provide an excellent veterinary service to clients and pets throughout the region.",
    "To create a happy working environment with job satisfaction for our valued staff.",
  ] },
  { icon: Cat, title: "Our Mission", points: [
    "To offer quality care for life, at a fair price to our valued clients and their pets.",
    "To treat our staff with respect, provide training, and inspire them to fulfil their career goals.",
  ] },
  { icon: Stethoscope, title: "Our Motto", points: [
    "Affordable, age-inclusive veterinary care for every family.",
  ] },
];

const Values = () => {
  return (
    <>
      {/* Partner logos marquee */}
      <section className="mx-auto max-w-[1290px] px-5 py-8">
        <div className="pw-marquee-wrap overflow-hidden">
          <div className="pw-marquee-track items-center gap-16">
            {[...logos, ...logos, ...logos].map((l, i) => (
              <img
                key={i}
                src={`/pawelle/${l}.png`}
                alt={l}
                className="h-9 w-auto flex-shrink-0 opacity-80 grayscale transition hover:opacity-100 hover:grayscale-0"
              />
            ))}
          </div>
        </div>
      </section>

      {/* Our Value */}
      <section className="mx-auto max-w-[1290px] px-5 pt-14">
        <div className="grid items-center gap-8 lg:grid-cols-[0.9fr_1.1fr]">
          <Reveal animation="rubberBand">
            <span className="inline-flex items-center gap-2 font-display text-[15px] font-semibold text-pawelle-primary">
              <PawPrint className="h-5 w-5" />
              Our Value
            </span>
            <h2 className="mt-3 font-display text-[28px] font-bold leading-tight text-pawelle-ink md:text-[34px]">
              Blending Science and Compassion in Pet Wellness Care
            </h2>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-[1290px] px-5 py-12">
        <div className="grid gap-6 md:grid-cols-3">
          {values.map((v, i) => {
            const Icon = v.icon;
            const anim = i === 0 ? "fadeInLeft" : i === 1 ? "fadeInUp" : "fadeInRight";
            return (
              <Reveal key={v.title} animation={anim} delay={i * 100} className="group rounded-[28px] bg-pawelle-bg p-8 transition-all duration-300 hover:bg-pawelle-primary">
                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-white text-pawelle-primary shadow-sm transition-colors group-hover:bg-white/15 group-hover:text-white">
                  <Icon className="h-8 w-8" />
                </div>
                <h3 className="mt-6 font-display text-[22px] font-semibold text-pawelle-ink transition-colors group-hover:text-white">
                  {v.title}
                </h3>
                <ul className="mt-3 space-y-2.5">
                  {v.points.map((pt) => (
                    <li key={pt} className="flex items-start gap-2.5 font-body text-[15px] leading-relaxed text-pawelle-body transition-colors group-hover:text-white/85">
                      <PawPrint className="mt-0.5 h-4 w-4 flex-shrink-0 text-pawelle-primary transition-colors group-hover:text-white/80" />
                      <span>{pt}</span>
                    </li>
                  ))}
                </ul>
              </Reveal>
            );
          })}
        </div>
      </section>
    </>
  );
};

export default Values;
